import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/ships/:ship_id?",
    name: "Ships",
    component: () =>
      import(/* webpackChunkName: "ships" */ "../views/Ships.vue"),
    props(route) {
      const props = { ...route.params };
      props.ship_id = +props.ship_id;
      return props;
    }
  },
  {
    path: "/esi/callback",
    redirect: to => {
      const { hash } = to;
      const hash_obj = Object.fromEntries(
        hash
          .substring(1)
          .split("&")
          .map(x => x.split("="))
      );
      store.dispatch("verifyCharacterId", decodeURIComponent(hash_obj.access_token));
      const redirect_obj = JSON.parse(
        window.localStorage.getItem("redirect_route")
      );
      return redirect_obj || { name: "Character", hash: "" };
    }
  },
  {
    path: "/character",
    name: "Character",
    component: () =>
      import(/* webpackChunkName: "character" */ "../views/Character.vue")
  },
  {
    path: "/fittings/:fitting_id?",
    name: "Fittings",
    component: () =>
      import(/* webpackChunkName: "fittings" */ "../views/Fittings.vue"),
    props(route) {
      const props = { ...route.params };
      props.fitting_id = +props.fitting_id;
      return props;
    }
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
});

export default router;
